import React from 'react';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { spacing } from '../../style';
import { IconProps } from '../icon/icon';

// components
import Icon from '../icon';

// constants
import { DEFAULT_INPUT_SIZE } from './input';
import { sizes as inputSizes } from './style';

export type InputContainerSizesType = keyof typeof inputSizes;
const sizes: Record<InputContainerSizesType, { padding: string }> = {
  '2xxl': {
    padding: '30px',
  },
  xxl: {
    padding: '30px',
  },
  xl: {
    padding: '40px',
  },
  lg: {
    padding: '30px',
  },
  md: {
    padding: '24px',
  },
  auto: {
    padding: '30px',
  },
};

interface InputContainerProps {
  icons?: Array<'left' | 'right'>;
  className?: string;
  children?: any;
  size?: InputContainerSizesType;
  paddingRight?: keyof typeof spacing;
  paddingLeft?: keyof typeof spacing;
}

const InputContainerComponent = styled.div<InputContainerProps>`
  position: relative;

  .input-utility-icon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    height: 100%;
    display: flex;
    align-items: center;
  }

  input.box-input,
  textarea.box-input {
    ${props =>
      props.icons &&
      props.icons.map(icon => css`padding-${icon}: ${sizes[props.size || DEFAULT_INPUT_SIZE]?.padding};`)}
    ${({ paddingRight }) =>
      paddingRight &&
      css`
        padding-right: ${spacing[paddingRight]};
      `}
    ${({ paddingLeft }) =>
      paddingLeft &&
      css`
        padding-left: ${spacing[paddingLeft]};
      `}
  }
`;

const IconContainer = ({ className, children }: InputContainerProps) => (
  <div className={classNames('input-utility-icon', className)}>{children}</div>
);

const InputContainer: React.FunctionComponent<InputContainerProps> & {
  LeftIconContainer: React.FunctionComponent<{ children?: React.ReactElement }>;
  RightIconContainer: React.FunctionComponent<{ children?: React.ReactElement }>;
  Icon: React.FunctionComponent<IconProps>;
  RightButtonContainer: React.FunctionComponent<{ children?: React.ReactElement }>;
} = props => <InputContainerComponent {...props} />;

InputContainer.LeftIconContainer = styled(IconContainer)`
  left: 12px;
`;

InputContainer.RightIconContainer = styled(IconContainer)`
  right: 12px;
`;

InputContainer.RightButtonContainer = styled(IconContainer)`
  right: 6px;
  z-index: 1;
`;

InputContainer.Icon = ({ ...rest }: IconProps) => <Icon variant={'gray600'} size={'lg'} {...rest} />;

export default InputContainer;
